export default [
  {
    path: "/projects/list",
    name: "projects-list",
    component: () => import("@/views/project/projects-list/projectsList.vue"),
    meta: {
      action: "read",
      resource: "projects",
    },
  },
  {
    path: "/projects-in-progress/list",
    name: "projects-list-in-progress",
    component: () => import("@/views/project/projects-list/projectsList.vue"),
    meta: {
      action: "read",
      resource: "projects",
    },
  },
  {
    path: "/projects-in-quoting/list",
    name: "projects-list-in-quoting",
    component: () => import("@/views/project/projects-list/projectsList.vue"),
    meta: {
      action: "read",
      resource: "projects",
    },
  },
  // {
  //   path: "/project/view/:id",
  //   name: "project-view",
  //   component: () => import("@/views/project/project-view/projectView.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "projects",
  //   },
  // },
  {
    path: "/project/edit/:id",
    name: "project-edit",
    component: () => import("@/views/project/project-edit/projectEdit.vue"),
    meta: {
      action: "update",
      resource: "projects",
    },
  },
  {
    path: "/project/create",
    name: "project-create",
    component: () => import("@/views/project/project-edit/projectEdit.vue"),
    meta: {
      action: "create",
      resource: "projects",
    },
  },



  // {
  //   path: "/orders/list",
  //   name: "order-list",
  //   component: () => import("@/views/order/orders-list/ordersList.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "orders",
  //   },
  // },
  {
    path: "/order/view/:id",
    name: "order-view",
    component: () => import("@/views/order/order-view/orderView.vue"),
    meta: {
      action: "view_detail",
      resource: "projects",
    },
  },
  {
    path: "/order/customer-view",
    name: "order-customer-view",
    component: () => import("@/views/order/order-view/orderView.vue"),
    meta: {
      action: "view_detail",
      resource: "projects",
    },
  },
  // {
  //   path: "/order/edit/:id",
  //   name: "order-edit",
  //   component: () => import("@/views/order/order-edit/orderEdit.vue"),
  //   meta: {
  //     action: "update",
  //     resource: "orders",
  //   },
  // },
  // {
  //   path: "/order/create",
  //   name: "order-create",
  //   component: () => import("@/views/order/order-edit/orderEdit.vue"),
  //   meta: {
  //     action: "create",
  //     resource: "orders",
  //   },
  // },
]